import React from "react";
import useDarkMode from "@/hooks/useDarkMode";
import { Link } from "react-router-dom";
import useWidth from "@/hooks/useWidth";

import MainLogo from "@/assets/images/logo/logosway.png";
import LogoWhite from "@/assets/images/logo/logosway.png";
import MobileLogo from "@/assets/images/logo/logosway.png";
import MobileLogoWhite from "@/assets/images/logo/logosway.png";
const Logo = () => {
  const [isDark] = useDarkMode();
  const { width, breakpoints } = useWidth();

  return (
    <div>
      <Link to="/dashboard" className="flex items-center space-x-3">
        <img 
          src={isDark ? LogoWhite : MainLogo} 
          alt="" 
          className="h-8 w-auto"
          style={{ maxHeight: '32px', width: 'auto' }}
        />
        <span className="text-2xl font-bold text-slate-900 dark:text-white">
          mysway.
        </span>
      </Link>
    </div>
  );
};

export default Logo;
